var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"item-wrapper"},[_c('div',{staticClass:"container-fluid",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"row"},_vm._l((_vm.coloredProducts),function(product){return _c('custom-product-quick-search-card',{key:product.id,attrs:{"coloredProduct":product,"gant":_vm.gant,"vermont":_vm.vermont}})}),1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }